const actions = {
  SET_STATE: 'organizer/SET_STATE',
  REFRESH_ERRORS: 'organizer/REFRESH_ERRORS',
  ALL: 'organizer/ALL',
  FETCH_ALL: 'organizer/FETCH_ALL',
  DETAILS: 'organizer/DETAILS',
  ADD: 'organizer/ADD',
  EDIT: 'organizer/EDIT',
  REMOVE: 'organizer/REMOVE'
};

export default actions
